import { Action, Reducer } from "redux";
import { ToastAction, ToastDismiss, ToastPush } from "./Toasts.Actions";
import { ToastDefaultState, ToastState } from "./Toasts.State";

export const ToastReducer: Reducer<ToastState> = (
    state: ToastState | undefined,
    incomingAction: Action
): ToastState => {
    if(state == undefined) {
        return ToastDefaultState;
    }
    const action = incomingAction as ToastAction;
    switch(action.type) {
        case 'TOAST_PUSH':
            return pushToast(state, action);
        case 'TOAST_PUSH_LEGACY':
            return { ...state, toasts: [action.toast, ...state.toasts] };
        case 'TOAST_PUSH_RANGE':
            return { ...state, toasts: [...action.toasts, ...state.toasts] };
        case 'TOAST_DISMISS':
            return dismissToast(state, action);
        default:
            return state;
    }
}

const pushToast = (state: ToastState, action: ToastPush): ToastState => {
    const { id, message, toastType: type } = action;
    const toast = { id, message, type };
    return { ...state, toasts: [toast, ...state.toasts] };
}

const dismissToast = (state: ToastState, action: ToastDismiss): ToastState => {
    const { id } = action;
    const toast = state.toasts.find(toast => toast.id == id);
    if (toast == null) {
        return state;
    }

    return { ...state, toasts: [...state.toasts.filter(toast => toast.id != id)] };
}